import {createStore} from 'vuex'
import UserInfoDto from "@/dto/UserInfoDto";

export default createStore({
  state: {
    loading: false,
    config: null as { [key: string]: string }|null,
    userInfo: null as UserInfoDto|null,
    applicationVersion: null as string|null,
  },
  getters: {
    loading(state){
      return state.loading
    },
    config(state){
      return state.config
    },
    userInfo(state){
      return state.userInfo
    },
    applicationVersion(state){
      return state.applicationVersion
    },
  },
  mutations: {
    setLoading(state, loading: boolean){
      state.loading = loading
    },
    setConfig(state, config: {[key: string]: string }){
      state.config = config
    },
    setUserInfo(state, userInfo: UserInfoDto){
      state.userInfo = userInfo
    },
    setApplicationVersion(state, applicationVersion: string){
      state.applicationVersion = applicationVersion
    },
  },
  actions: {
  },
  modules: {
  }
})
